export const DEFAULT_VIEWER_CONFIG = {
  cameraOrbit: "0deg 75deg auto",
  cameraTarget: "auto auto auto",
  fieldOfView: "30deg",
  minCameraOrbit: "auto auto auto",
  maxCameraOrbit: "auto auto auto",
  minFieldOfView: "10deg",
  maxFieldOfView: "45deg",
  autoRotate: false,
  exposure: "1",
  environmentPreset: "neutral",
};

export const ENVIRONMENT_PRESETS = {
  neutral: {
    label: "Neutral",
    environmentImage: "neutral",
    toneMapping: "neutral",
    stageClass:
      "from-zinc-100 via-white to-zinc-200 dark:from-zinc-950 dark:via-zinc-900 dark:to-zinc-950",
    description: "Balanced neutral lighting for general product review.",
  },
  legacy: {
    label: "Legacy",
    environmentImage: "legacy",
    toneMapping: "neutral",
    stageClass:
      "from-zinc-200 via-white to-stone-100 dark:from-zinc-950 dark:via-zinc-900 dark:to-stone-950",
    description: "Classic fallback lighting with softer contrast.",
  },
  commerce: {
    label: "Commerce",
    environmentImage: "neutral",
    toneMapping: "neutral",
    stageClass:
      "from-slate-100 via-white to-sky-50 dark:from-slate-950 dark:via-zinc-900 dark:to-sky-950/60",
    description: "Clean storefront-style lighting for practical product framing.",
  },
  studio: {
    label: "Studio",
    environmentImage: "neutral",
    toneMapping: "aces",
    stageClass:
      "from-neutral-100 via-white to-neutral-200 dark:from-neutral-950 dark:via-zinc-900 dark:to-neutral-900",
    description: "Higher-contrast studio feel for polished marketing previews.",
  },
  forest: {
    label: "Forest",
    environmentImage: "neutral",
    toneMapping: "agx",
    stageClass:
      "from-emerald-100 via-lime-50 to-green-100 dark:from-emerald-950 dark:via-zinc-900 dark:to-green-950",
    description: "Cooler green-toned staging without changing the environment source.",
  },
  night: {
    label: "Night",
    environmentImage: "legacy",
    toneMapping: "aces",
    stageClass:
      "from-slate-900 via-zinc-950 to-indigo-950 dark:from-slate-950 dark:via-black dark:to-indigo-950",
    description: "Darker scene staging for high-contrast silhouette checks.",
  },
  sunset: {
    label: "Sunset",
    environmentImage: "legacy",
    toneMapping: "agx",
    stageClass:
      "from-orange-100 via-rose-50 to-amber-100 dark:from-orange-950 dark:via-rose-950/70 dark:to-amber-950",
    description: "Warm staging for poster-like previews without changing the model asset.",
  },
};

export function mergeViewerConfig(config = {}) {
  const environmentPreset = String(
    config?.environmentPreset || DEFAULT_VIEWER_CONFIG.environmentPreset
  ).toLowerCase();

  return {
    ...DEFAULT_VIEWER_CONFIG,
    ...(config || {}),
    autoRotate: Boolean(config?.autoRotate),
    exposure: String(config?.exposure ?? DEFAULT_VIEWER_CONFIG.exposure),
    environmentPreset: ENVIRONMENT_PRESETS[environmentPreset]
      ? environmentPreset
      : DEFAULT_VIEWER_CONFIG.environmentPreset,
  };
}
